import { CompanyTag } from '@/components/ui/badge'
import { formatLocalDateUTC } from '@/utils/date'
import { GridCellProps } from '@progress/kendo-react-grid'
import { GridColumn } from 'routes/Transactions/transactionIBTransactionsColumns'

export const rebateSettingsColumns: GridColumn[] = [
  {
    title: 'IB Entity',
    field: 'ibEntity',
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td>
          <CompanyTag id={props.dataItem.ibEntity.id}>{props.dataItem.ibEntity.name}</CompanyTag>
        </td>
      )
    },
    resizable: true,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 400,
  },
  {
    title: 'Automation Cap',
    field: 'automationCapInUsd',
    cell: (props: GridCellProps): JSX.Element => {
      return <td>{props.dataItem.automationCapInUsd}</td>
    },
    resizable: true,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 400,
  },
  {
    title: 'Last Updated',
    field: 'updatedAt',
    cell: (props: GridCellProps) => <td>{formatLocalDateUTC(props.dataItem.updatedAt, true)}</td>,
    resizable: true,
    show: true,
    className: 'table-columns__date',
    filter: 'text',
    width: 400,
  },
]
